import { AbstractModel } from './AbstractModel'

export class Term extends AbstractModel {
  public id: number|null = null;
  public name: string|null = null;
  public term: string|null = null;
}
